import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import './PaymentSummary.css';
import { submitPayment } from '../../utils/paymentService';
import PaymentDetails from '../payment/PaymentDetails';
import SecretCodePopup from '../payment/SecretCodePopup';

const PaymentSummary = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { training, formData } = location.state;
    const [secretCode, setSecretCode] = useState('');
    const [showSecretCodePopup, setShowSecretCodePopup] = useState(false);
    const [clientIp, setClientIp] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const calendarApiUrl = process.env.REACT_APP_CALENDAR_API_URL || process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchClientIp = async () => {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                setClientIp(data.ip);
            } catch (error) {
                console.error('Error fetching client IP:', error);
            }
        };

        fetchClientIp();
    }, []);

    const handleBack = () => {
        navigate(-1);
    };

    const handlePayment = () => {
        if (formData.paymentMethod === 'PayU') {
            handlePayUSubmit();
        } else if (formData.paymentMethod === 'Secret Code') {
            setShowSecretCodePopup(true);
        }
    };

    const handlePayUSubmit = async () => {
        setIsLoading(true);
        const payload = {
            amount: training.amount * 100,
            email: formData.email,
            phone: formData.phone,
            first_name: formData.name,
            last_name: formData.lastname,
            product_name: training.summary,
            customerIp: clientIp,
            description: 'Training payment',
            additionalDescription: `event_id: ${training.id}`,
            notifyUrl: `${calendarApiUrl}/api/calendar`,
            continueUrl: `${calendarApiUrl}/`
        };

        try {
            const responseData = await submitPayment(payload);
            console.log('responseData:', responseData); // Debugging line
            if (responseData && responseData.redirectUri) {
                window.location.href = responseData.redirectUri;
            } else {
                throw new Error('Invalid response from payment service');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Payment failed. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSecretCodeSubmit = async () => {
        setIsLoading(true);
        // Handle secret code submission logic here
        // For example, validate the secret code and apply discount or free registration
        try {
            // Assuming validateSecretCode is a function that validates the secret code
            // const isValid = await validateSecretCode(secretCode);
            const isValid = true;
            if (isValid) {
                navigate(`/order-status/success`);
            } else {
                alert('Invalid secret code. Please try again.');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Secret code validation failed. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="payment-summary">
            <div className="progress-bar">
                <div className="progress" style={{ width: '100%' }}></div>
                <div className="steps">
                    <div className="step active">1</div>
                    <div className="step active">2</div>
                    <div className="step active">3</div>
                </div>
            </div>
            <h2>Payment Summary</h2>
            <PaymentDetails training={training} formData={formData} />
            <div className="payment-buttons">
                {isLoading ? (
                    <div className="loading-circle"></div>
                ) : (
                    <>
                        <button className="payment-button" onClick={handlePayment}>Make Payment</button>
                        <button className="back-button" onClick={handleBack}>Back</button>
                    </>
                )}
            </div>
            {showSecretCodePopup && (
                <SecretCodePopup secretCode={secretCode} setSecretCode={setSecretCode} handleSecretCodeSubmit={handleSecretCodeSubmit} />
            )}
        </div>
    );
};

export default PaymentSummary;
